module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ai-ask-page"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "ai-ask-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-section"
  }, [_c('el-input', {
    staticClass: "question-input",
    attrs: {
      "type": "textarea",
      "rows": 6,
      "placeholder": "请输入您的问题...",
      "disabled": _vm.loading
    },
    model: {
      value: (_vm.question),
      callback: function($$v) {
        _vm.question = $$v
      },
      expression: "question"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "disabled": !_vm.question.trim(),
      "size": "large"
    },
    on: {
      "click": _vm.askQuestion
    }
  }, [_vm._v("\n            " + _vm._s(_vm.loading ? '提问中...' : '提问') + "\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "size": "large"
    },
    on: {
      "click": _vm.clearInput
    }
  }, [_vm._v("\n            清空\n          ")])], 1)], 1), _vm._v(" "), (_vm.qaList.length > 0) ? _c('div', {
    staticClass: "qa-list"
  }, [_c('h2', {
    staticClass: "list-title"
  }, [_vm._v("问答记录")]), _vm._v(" "), _vm._l((_vm.qaList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "qa-item"
    }, [_c('el-card', {
      staticClass: "question-card",
      attrs: {
        "shadow": "never"
      }
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('i', {
      staticClass: "el-icon-question"
    }), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v("问题")]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_vm._v("\n              " + _vm._s(item.question) + "\n            ")])]), _vm._v(" "), _c('el-card', {
      staticClass: "answer-card",
      attrs: {
        "shadow": "hover"
      }
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('i', {
      staticClass: "el-icon-chat-dot-round"
    }), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v("答案")]), _vm._v(" "), (item.method) ? _c('el-tag', {
      attrs: {
        "size": "small",
        "type": _vm.getMethodType(item.method)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getMethodText(item.method)) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "card-content answer-content"
    }, [_vm._v("\n              " + _vm._s(item.answer) + "\n            ")]), _vm._v(" "), (item.source) ? _c('div', {
      staticClass: "source-section"
    }, [_c('div', {
      staticClass: "source-label"
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _vm._v("\n                来源说明：\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "source-content"
    }, [_vm._v("\n                " + _vm._s(item.source) + "\n              ")])]) : _vm._e()])], 1)
  })], 2) : _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "el-icon-chat-line-square"
  }), _vm._v(" "), _c('p', [_vm._v("暂无问答记录，请输入问题开始提问")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("RAG法律智能问答")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("输入您的问题，获取智能答案")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48a1c058","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/AiAsk.vue
// module id = 1468
// module chunks = 0